import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Button } from "rbx";
import DeleteButton from "./DeleteButton";

function EditFormButtonGroup({
  form,
  deleteMutation,
  variables,
  refetchQueries,
  onComplete,
  confirmModalMessage,
  loading
}) {
  return (
    <React.Fragment>
      <hr />
      <Field kind="group">
        <Control expanded>
          <Field kind="group">
            <Control>
              <Button
                color="success"
                form={form}
                state={loading ? "loading" : ""}
                type="submit"
              >
                Save
              </Button>
            </Control>
            <Control>
              <Button disabled={loading} type="button" onClick={onComplete}>
                Cancel
              </Button>
            </Control>
          </Field>
        </Control>

        <Control>
          <DeleteButton
            confirmModalMessage={confirmModalMessage}
            isDispatcher={loading}
            mutation={deleteMutation}
            refetchQueries={refetchQueries}
            variables={variables}
            onComplete={onComplete}
          >
            OKAY
          </DeleteButton>
        </Control>
      </Field>
    </React.Fragment>
  );
}

EditFormButtonGroup.propTypes = {
  form: PropTypes.string,
  deleteMutation: PropTypes.object,
  variables: PropTypes.object,
  onComplete: PropTypes.func,
  refetchQueries: PropTypes.array,
  confirmModalMessage: PropTypes.string,
  loading: PropTypes.bool
};

EditFormButtonGroup.defaultProps = {
  loading: false
};
export default EditFormButtonGroup;
